import { useEffect, useState } from 'react';
import { StopAreaApiModel } from '../models/stop-area.api-model';
import { ConfigurationService } from '../../../services/configuration.service';
import { AnalyticsService } from '../../../services/analytics-service';
import { TranslationService } from '../../../services/translation.service';
import DepartureBoardLinkHelper from '../../../helpers/departure-board-link.helper';
import OverlayBox from '../../Shared/OverlayBox';
import StopAreaMap from '../StopAreaMap';
import type { IStopArea } from '../../../models/stop-area.model';
import './style.scss';
import StopAreaMapHelper from '../StopAreaMap/helpers/stop-area-map.helper';
import useFetch from '../../../hooks/fetch.hook';

function processReceivedData(data: StopAreaApiModel | undefined): IStopArea | undefined {
  return data ? StopAreaApiModel.mapToBusinessModel(data) : undefined;
}

function StopAreaSearchDetailsComponent() {
  // === CONSTANTS ===
  const stopAreaGid = ConfigurationService.get('stopareasearchpage.stopareagid');
  const departureBoardUrl = DepartureBoardLinkHelper.generateLink(stopAreaGid, undefined, 'vasttrafikse-stopareadetailspage');

  // === STATE ===
  const [{ data: getStopAreaData }] = useFetch<StopAreaApiModel>(`/api/stop-area-search/stopareas/${stopAreaGid}`);
  const [overlayContentText, setOverlayContentText] = useState('');

  // === VARIABLES ===
  const stopArea = processReceivedData(getStopAreaData);

  useEffect(() => {
    setOverlayContentText(
      TranslationService.get('stopareasearchpage.prefixoverlayboxcontenttext').replace(
        '{0}',
        `${TranslationService.get('stopareasearchpage.stopareaname')} ${TranslationService.get('stopareasearchpage.tracktext').toLocaleLowerCase()} ${stopArea?.stopPoints
          .map((sp) => sp.platform)
          .join(', ')}`
      )
    );
  }, [stopArea]);

  function handleOnDepartureLinkClicked() {
    AnalyticsService.addEvent(AnalyticsService.StopArea, 'Detaljsida - klick på länk till avgångstavla', '');
  }

  function handleOnOverlayBoxLoad() {
    StopAreaMapHelper.moveBreadcrumbs('stopareasearchpage-breadcrumbs');
  }

  return (
    <div className="stop-area-search-details">
      <OverlayBox
        headerText={TranslationService.get('stopareasearchpage.stopareaheader')}
        contentText={overlayContentText}
        contentImageUrl={ConfigurationService.get('stopareasearchpage.overlayboxcontentimageurl')}
        contentImageAltText={TranslationService.get('stopareasearchpage.overlayboxcontentimagealttext')}
        externalLinkText={TranslationService.get('stopareasearchpage.departureboardlinktext')}
        externalLinkUrl={departureBoardUrl}
        onExternalLinkClick={handleOnDepartureLinkClicked}
        onLoad={handleOnOverlayBoxLoad}
      />
      <StopAreaMap mapClassName="stop-area-search-details" stopPoints={stopArea?.stopPoints} />
    </div>
  );
}

export default StopAreaSearchDetailsComponent;
